import { 
    CreateTransportLocationDto, 
    DeleteTransportLocationDto,
    EditTransportLocationDto,
    GetTransportLocationDto, 
    MessageResponseDto, 
    UtilityTransportLocationApiFp,
    UtilTransportLocationControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseUtilTransportLocationModel = UtilTransportLocationControllerGet200Response;
export type GetUtilTransportLocationModel = GetTransportLocationDto;
export type MutateResponseUtilTransportLocationModel = MessageResponseDto;
export type CreateUtilTransportLocationModel = CreateTransportLocationDto;
export type UpdateUtilTransportLocationModel = EditTransportLocationDto;
export type DeleteUtilTransportLocationModel = DeleteTransportLocationDto;

export const apiUtilTransportLocationFp =  UtilityTransportLocationApiFp(apiConfig);
export const getUtilTransportLocationController = apiUtilTransportLocationFp.utilTransportLocationControllerGet;
export const createUtilTransportLocationController = apiUtilTransportLocationFp.utilTransportLocationControllerCreate;
export const updateUtilTransportLocationController = apiUtilTransportLocationFp.utilTransportLocationControllerEdit;
export const deleteUtilTransportLocationController = apiUtilTransportLocationFp.utilTransportLocationControllerDelete;

export const QueryKeyUtilTransportLocation = QueryKey.UtilTransportLocation;